import { NgClass, NgStyle, NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import format from 'date-fns/format';
import { FormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  selector: 'app-business-review-item',
  templateUrl: './business-review-item.component.html',
  styleUrls: ['./business-review-item.component.scss'],
  standalone: true,
  imports: [ToggleSwitchModule, FormsModule, NgClass, NgStyle, NgIf],
  encapsulation: ViewEncapsulation.None
})
export class BusinessReviewItemComponent implements OnInit, OnChanges {
  @Input() review: any;
  @Input() isOrganization: boolean = false;

  @Output() handleMenu: EventEmitter<any> = new EventEmitter();
  @Output() handleVideo: EventEmitter<any> = new EventEmitter();
  @Output() isShow: EventEmitter<any> = new EventEmitter();

  @Input() scale = 0.85;
  @Input() businessType: string;

  createdAt: string;
  videoWidth: number = Math.round(320 * this.scale);
  videoHeight: number = Math.round(180 * this.scale);

  @ViewChild('coverImage') coverImage: ElementRef;

  isCoverLandscape = true;
  averageRating = 0;

  constructor() {}

  @HostBinding('style.--scale-factor-main')
  get scaleFactor() {
    return this.scale;
  }

  toggleMenu(event: Event) {
    event.stopPropagation();
    this.handleMenu.next({ event, reviewId: this.review.id });
  }

  onVideoClick(event: Event) {
    this.handleVideo.next(event);
  }

  calcCover() {
    this.isCoverLandscape =
      this.coverImage.nativeElement.naturalWidth /
        this.coverImage.nativeElement.naturalHeight >
      1.33;
  }

  ngOnInit(): void {
    if (this.review) {
      this.averageRating =
        (+this.review.customerService + +this.review.quality) / 2;
      this.createdAt = format(
        new Date(Number(this.review.createdAt)),
        'MM/dd/yyyy'
      );
    }
  }

  setTestimonialVisibility(e: any) {
    this.isShow.emit(e);
  }

  ngOnChanges() {
    this.videoWidth = Math.round(320 * this.scale);
    this.videoHeight = Math.round(180 * this.scale);
  }
}
